import {
  AbstractControl,
  AsyncValidatorFn,
  ValidationErrors,
} from "@angular/forms";
import { UserService } from "../../edtell-admin/services/user.service";

export function validateEmail(
  userService: UserService,
  userId?: number,
): AsyncValidatorFn {
  return async (control: AbstractControl): Promise<ValidationErrors> => {
    const resp = await userService
      .isUniqueEmail(control.value, userId)
      .toPromise();
    return !resp ? { notUnique: true } : null;
  };
}
